import type { Site, SiteV3 } from '@/entities/sites/api/types';

const convertToOptions = (
  sites: Pick<Site, 'id' | 'url'>[] | Pick<SiteV3, 'id' | 'domain'>[]
) =>
  sites.map((site) => {
    let label = '';

    if ('url' in site) {
      label = site.url;
    } else if ('domain' in site) {
      label = site.domain;
    }

    return {
      label,
      value: site.id,
    };
  });

export default convertToOptions;
